import { FleetTireAddRow, TireType } from "./types";

export const getDimensionSet = (tires: FleetTireAddRow[]) => {
    const dimension = Array.from(
        new Set(
            tires
                ?.map(r => `${r.width}/${r.height} R${r.radius}`)
                .filter(Boolean)
        )
    ).join(", ");
    return dimension
}

export const getTireType = (tires: FleetTireAddRow[]): TireType | null => {
    if (!tires?.length) return null;
    return tires[0].tireType ?? null;
};

export const getTireIcon = (tires: FleetTireAddRow[]) => {
    let tireType = getTireType(tires);

    switch (tireType?.id) {
        case "S":
            return <img src="/media/images/summer.png" alt="" width={48} />;
        case "W":
            return <img src="/media/images/winter.png" alt="" width={48} />;
        case "U":
            return <img src="/media/images/allseason.png" alt="" width={48} />;
        default:
            return "";
    }

}

export const getTireManufacturers = (tires: FleetTireAddRow[]) => {
    const tireManufacturers = Array.from(
        new Set(
            tires
                ?.map(r => `${r.tireManufacturer?.name}`)
                .filter(Boolean)
        )
    ).join(", ");

    return tireManufacturers;
}